import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import InfoModal from '@exchange/libs/modals/src/lib/common/InfoModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UkSelfCertificationModal',
  props: {
  phase: { type: Number, required: true },
},
  emits: ["close", "go-to-form"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    testid: "uk-certification-modal",
    variant: "dark",
    "no-icon": true,
    action: "ui.ukSelfCertification.primaryAction",
    "action-test-id": "go-to-form",
    "action-secondary": __props.phase === 0 ? 'ui.ukSelfCertification.secondaryAction' : undefined,
    "action-secondary-test-id": "later",
    "content-test-id": "uk-certification-modal-content",
    title: "ui.ukSelfCertification.title",
    message: __props.phase === 0 ? _ctx.$t('ui.ukSelfCertification.description.before') : _ctx.$t('ui.ukSelfCertification.description.after'),
    onActionClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('go-to-form'))),
    onActionSecondaryClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, null, 8, ["action-secondary", "message"]))
}
}

})